import { useCallback, useMemo } from "react";

import { usePlanFeature } from "hooks";
import { useFeatures } from "components/FeatureFlag";

import {
  useGetPracticeSubscription,
  useSubscribeToChangePlan,
  useSubscribeToSubscriptionChanged,
} from ".";

function useMeetingDatesSyncEligibility(practiceId, shouldSyncMeetings) {
  const {
    loading: loadingPlanFeature,
    eligibility,
    reloadData: reloadPlanFeature,
  } = usePlanFeature("meeting-dates-sync");
  const { show = false, ...meetingDatesSyncFF } = useFeatures(
    "meeting-dates-sync-upgrade-plan"
  );

  const {
    subscription,
    loading: loadingSubscription,
    reloadData,
  } = useGetPracticeSubscription(practiceId, false);

  useSubscribeToChangePlan({
    onPlanChanged: useCallback(reloadData, [reloadData]),
  });

  useSubscribeToSubscriptionChanged({
    onSubscriptionChanged: useCallback(
      (subscriptionId) => {
        if (subscriptionId === subscription?.id) {
          reloadData();
          reloadPlanFeature();
        }
      },
      [reloadData, reloadPlanFeature, subscription]
    ),
  });

  const loadingEligibility = useMemo(() => {
    return loadingPlanFeature || loadingSubscription;
  }, [loadingPlanFeature, loadingSubscription]);

  return {
    loadingEligibility: loadingEligibility,
    renderEligibilityTooltip:
      show &&
      !shouldSyncMeetings &&
      !loadingEligibility &&
      !eligibility?.eligible &&
      !subscription?.pendingChanges,
    renderPendingChanges:
      !shouldSyncMeetings && Boolean(subscription?.pendingChanges),
    eligibilityTooltipProps: { ...meetingDatesSyncFF, eligibility },
  };
}

export default useMeetingDatesSyncEligibility;
